import { render, staticRenderFns } from "./ModalContentPage.vue?vue&type=template&id=5b3bef4c&scoped=true&"
import script from "./ModalContentPage.vue?vue&type=script&lang=js&"
export * from "./ModalContentPage.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentPage.vue?vue&type=style&index=0&id=5b3bef4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3bef4c",
  null
  
)

export default component.exports